import { useEffect, useState } from 'react';
import { Building2 } from 'lucide-react';
import KpiDateFilterBar from '../../components/KpiDateFilterBar';
import PerformanceKpiTable from '../../components/PerformanceKpiTable';
import PerformanceKpiTiles from '../../components/PerformanceKpiTiles';
import { useKpiDateFilter } from '../../utils/kpiDateFilter';
import api from '../../utils/api';

export default function AdminKpiAnalytics() {
    const dateFilter = useKpiDateFilter();
    const [officeBranch, setOfficeBranch] = useState('all');
    const [offices, setOffices] = useState([]);

    /* Load office list from OrgDirectory */
    useEffect(() => {
        api.get('/org-directory')
            .then(r => {
                const list = (r.data.grouped?.office || [])
                    .filter(o => o.active)
                    .map(o => o.label);
                setOffices(list);
            })
            .catch(() => { /* non-fatal */ });
    }, []);

    return (
        <div className="space-y-5">
            {/* Page header */}
            <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                    <h1 className="text-2xl font-extrabold">Sales KPI analytics</h1>
                    <p className="text-sm text-ink-500 mt-1">
                        Company-wide funnel from the daily meetings sheet — Marketing → BDA → BDE. Filter by date to see leads received day-wise.
                    </p>
                </div>

                {/* Office filter — top right */}
                <div className="flex items-center gap-2 shrink-0">
                    <Building2 className="h-4 w-4 text-ink-400" />
                    <div className="flex flex-col">
                        <span className="text-[10px] uppercase tracking-wider text-ink-400 font-semibold mb-0.5">Office</span>
                        <select
                            value={officeBranch}
                            onChange={e => setOfficeBranch(e.target.value)}
                            className="ag-input text-sm min-w-[160px]"
                        >
                            <option value="all">All offices</option>
                            {offices.map(o => (
                                <option key={o} value={o}>{o}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            <KpiDateFilterBar {...dateFilter} />

            <PerformanceKpiTiles
                scope="org"
                embedded
                showFunnel
                hideActions
                dateParams={dateFilter.apiParams}
                periodLabel={dateFilter.label}
                officeBranch={officeBranch}
            />

            <PerformanceKpiTable
                scope="org"
                dateParams={dateFilter.apiParams}
                hideDateFilter
                officeBranch={officeBranch}
            />
        </div>
    );
}
